module.exports = __webpack_public_path__ + "static/media/Frame 2814.1c2fa21e.jpg";